import request from '@/router/axios'
import env from '@/config/env'
import { pickBy } from 'lodash-es'

// 保存
export function save(data) {
  return request({
    url: env.ferryUrl + '/activityFirstOrder/save',
    method: 'post',
    data
  })
}

// 获取供应商
export function getMerchantList() {
  return request({
    url: env.ferryUrl + '/couponBatch/getMerchantList',
    method: 'post'
  })
}

// 获取分页列表
export function list(patams) {
  return request({
    url: env.ferryUrl + '/activityFirstOrder/page',
    method: 'post',
    data: patams
  })
}

// 编辑
export function edit(data) {
  return request({
    url: env.ferryUrl + '/activityFirstOrder/edit',
    method: 'post',
    data
  })
}
export function detailsById(id) {
  return request({
    url: env.ferryUrl + `/activityFirstOrder/getById/${id}`,
    method: 'post'
  })
}

export function detailsViewDataById(id) {
  return request({
    url: env.ferryUrl + `/activityFirstOrder/getByActivityFirstOrderId/${id}`,
    method: 'post'
  })
}

export function dataPage(data) {
  return request({
    url: env.ferryUrl + '/activityFirstOrder/page/record',
    method: 'post',
    data
  })
}
/** ==================================================手动发券调用============================================================================== */
// 分页列表
export function sendCouponPage(data) {
  return request({
    url: env.ferryUrl + '/activityCoupon/activityCouponPage',
    method: 'post',
    data
  })
}

// 创建发券
export function addSendCoupon(data) {
  return request({
    url: env.ferryUrl + '/activityCoupon/create/activityCoupon',
    method: 'post',
    data
  })
}

// 查询详情
export function detaSendCoupon(id) {
  return request({
    url: env.ferryUrl + `/activityCoupon/getActivityCouponById/${id}`,
    method: 'get'
  })
}
// 手动发券详情信息
export function activityCouponDetail(id) {
  return request({
    url: env.ferryUrl + `/activityCoupon/activityCouponDetail/${id}`,
    method: 'get'
  })
}

// 选择优惠券
export function selectCouponpPage(data) {
  return request({
    url: env.ferryUrl + '/activityCoupon/choose/page',
    method: 'post',
    data
  })
}

// 审核
export function auditCouponp(data) {
  return request({
    url: env.ferryUrl + '/activityCoupon/activityCouponChangeState',
    method: 'post',
    data
  })
}

/**
 * 下载有效订单信息
 * @param data
 */
export const exportOrder = (queryParam) => {
  let url = env.importExcelUrl + env.ferryUrl + '/activityCoupon/export-consumer-order'
  const parma = pickBy({ ...queryParam })
  url = url + '/' + parma.startTime + '/' + parma.endTime + '/' + parma.unionId
  // return window.location.href = url
  window.location.href = url
}

/**
 * 获取手动发券列表
 * @param data
 *
 */
export const getReceivePage = (data) => {
  return request({
    url: env.ferryUrl + '/receive/coupon/page',
    method: 'POST',
    data
  })
}

/**
 * 保存或更新
 * @param data
 *
 */
export const saveOrUpdate = (data) => {
  return request({
    url: env.ferryUrl + '/receive/coupon/saveOrUpdate',
    method: 'POST',
    data
  })
}
/**
 * 手动领券活动详情
 * @param data
 *
 */
export const getInfo = (id) => {
  return request({
    url: env.ferryUrl + `/receive/coupon/receive-coupon/${id}`,
    method: 'GET'
  })
}
/**
 * 修改领券活动状态
 * @param data
 *
 */
export const changeStatus = (data) => {
  return request({
    url: env.ferryUrl + '/receive/coupon/changeStatus',
    method: 'POST',
    data
  })
}
/**
 * 创建返程券券活动
 * @param data
 *
 */
export const roundTripCreate = (data) => {
  return request({
    url: env.ferryUrl + '/round-trip/create',
    method: 'POST',
    data
  })
}
/**
 * 创建返程券券活动
 * @param data
 *
 */
export const roundTripInfo = (data) => {
  return request({
    url: env.ferryUrl + '/round-trip/couponId',
    method: 'GET',
    data
  })
}

/**
 * 创建助力活动
 * @param data
 *
 */
export const helpCreate = (data) => {
  return request({
    url: env.ferryUrl + '/help/create',
    method: 'POST',
    data
  })
}
/**
 * 获取生效的助力活动
 * @param data
 *
 */
export const helpInfo = (data) => {
  return request({
    url: env.ferryUrl + '/help/info',
    method: 'GET',
    data
  })
}

/**
 * 限时领券活动预览
 * @param data
 *
 */
export const limitedInfo = (id) => {
  return request({
    url: env.ferryUrl + '/receive/coupon/limited-info/' + id,
    method: 'GET'
  })
}

/**
 * 获取用户标签
 * @param data
 *
 */
export const memberTagList = () => {
  return request({
    url: env.ferryUrl + '/round-trip/memberTag/list',
    method: 'GET'
  })
}
